"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var Category = function (_a) {
    var item = _a.item, activeItem = _a.activeItem, childIndex = _a.childIndex, onChange = _a.onChange;
    var ref = react_1.useRef();
    function handleOpen() {
        if (!ref.current) {
            console.error("This error shouldn't happen");
            return;
        }
        var rect = ref.current.getBoundingClientRect();
        // const rect = ref.current.children[0].getBoundingClientRect();
        if (!(rect instanceof DOMRect)) {
            return;
        }
        var addon = ref.current.offsetWidth * childIndex;
        var addonY = ref.current.scrollHeight;
        // Viewpoort always expands downwards initially
        // if (rect.top < 0) {
        //     console.log("top")
        //     ref.current.style.bottom = `-${addonY}px`;
        // }
        // Viewport always expands to the right initially
        // if (rect.left + addon < 0) {
        //     console.log("left")
        //     ref.current.style.right = `-${addon}px`;
        // }
        if (rect.bottom + addonY > (window.innerHeight || document.documentElement.clientHeight)) {
            ref.current.style.cssText = "top: -" + (addonY - ref.current.parentElement.offsetHeight - 10) + "px !important";
        }
        if (rect.left + addon > (window.innerWidth || document.documentElement.clientWidth)) {
            ref.current.style.left = "-" + addon + "px";
        }
    }
    return (react_1.default.createElement(semantic_ui_react_1.Dropdown, { className: "link item", text: item.text, pointing: "left", onOpen: function () { return setTimeout(handleOpen); } },
        react_1.default.createElement("div", { ref: function (el) { return ref.current = el; }, className: "menu transition" },
            react_1.default.createElement("div", { className: "menu transition visible menu-container" },
                react_1.default.createElement(exports.List, { list: item.list, activeItem: activeItem, childIndex: childIndex + 1, onChange: onChange })))));
};
exports.List = function (_a) {
    var list = _a.list, activeItem = _a.activeItem, _b = _a.childIndex, childIndex = _b === void 0 ? 1 : _b, onChange = _a.onChange;
    function handleChange(event, data) {
        if (!onChange) {
            return;
        }
        onChange(data);
    }
    if (!list) {
        return [];
    }
    return list.map(function (item) {
        if (item.list) {
            return (react_1.default.createElement(Category, { key: item.key, item: item, activeItem: activeItem, childIndex: childIndex, onChange: onChange }));
        }
        return (react_1.default.createElement(semantic_ui_react_1.Dropdown.Item, { key: item.key, text: item.text, value: item.key, onClick: handleChange, active: item.key === (activeItem ? activeItem.key : undefined) }));
    });
};
//# sourceMappingURL=Category.js.map